export class ChangePasswordModel {
    public userId: number;
    public currentPassword: string;
    public newPassword: string;
}